import { render, staticRenderFns } from "./CustomNavbarItem.vue?vue&type=template&id=b316a1fc&"
import script from "./CustomNavbarItem.vue?vue&type=script&lang=js&"
export * from "./CustomNavbarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports